import React from "react";
import useSkin from "@/hooks/useSkin";

interface CardOptions {
  children: any;
  title?: any;
  subtitle?: string;
  headerslot?: any;
  className?: string;
  bodyClass?: string;
  noborder?: boolean;
  titleClass?: string;
  footer?: any;
}

const Card = ({
  children,
  title,
  subtitle,
  headerslot,
  className = "custom-class",
  bodyClass = "p-6",
  noborder,
  titleClass = "custom-class",
  footer,
}: CardOptions) => {
  const [skin] = useSkin();

  return (
    <div
      className={`
        card rounded-md bg-white dark:bg-slate-800 flex flex-col justify-between ${
          skin === "bordered"
            ? " border border-slate-200 dark:border-slate-700"
            : "shadow-base"
        }
   
    ${className}
        `}
    >
      <div className="h-full">
        {(title || subtitle) && (
          <header className={`card-header ${noborder ? "no-border" : ""}`}>
            <div className="w-full">
              {title && (
                <div className={`card-title ${titleClass}`}>{title}</div>
              )}
              {subtitle && <div className="card-subtitle">{subtitle}</div>}
            </div>
            {headerslot && <div className="card-header-slot">{headerslot}</div>}
          </header>
        )}
        <main className={`card-body ${bodyClass}`}>{children}</main>
      </div>
      {!!footer && <footer className="card-body px-6">{footer}</footer>}
    </div>
  );
};

export default Card;
